// Ported from emotion_generation_engine/materials/emomap_cells.csv (commit e286a0c).
// Cell order, labels and angular intervals are intentionally preserved.
export interface LegacyEmotionCell { id: number; layer: number; start: number; end: number; label: string }
export interface LegacyEmotionLink { id: string; source: number; target: number; sourceLayer: number; targetLayer: number }
export type LegacyManualName = "ENK" | "END" | "OXY" | "DA>T" | "DA<T" | "NA" | "VP" | "ACH" | "5HT>T" | "5HT<T" | "5HT=0";
export type LegacyDirectionName = LegacyManualName | "LEFT" | "RIGHT";

export const LEGACY_EMOTION_CELLS: readonly LegacyEmotionCell[] = Object.freeze([
  {
    "id": 0,
    "layer": 7,
    "start": 0,
    "end": 0.3588,
    "label": "自滅"
  },
  {
    "id": 1,
    "layer": 7,
    "start": 0.3588,
    "end": 0.5568,
    "label": "懺悔"
  },
  {
    "id": 2,
    "layer": 7,
    "start": 0.5568,
    "end": 0.7396,
    "label": "反省"
  },
  {
    "id": 3,
    "layer": 7,
    "start": 0.7396,
    "end": 0.9385,
    "label": "頑固"
  },
  {
    "id": 4,
    "layer": 7,
    "start": 0.9385,
    "end": 1.1591,
    "label": "無視"
  },
  {
    "id": 5,
    "layer": 7,
    "start": 1.1591,
    "end": 1.3751,
    "label": "拒絶"
  },
  {
    "id": 6,
    "layer": 7,
    "start": 1.3751,
    "end": 1.5708,
    "label": "根絶"
  },
  {
    "id": 7,
    "layer": 7,
    "start": 1.5708,
    "end": 1.7665,
    "label": "攻撃"
  },
  {
    "id": 8,
    "layer": 7,
    "start": 1.7665,
    "end": 1.9859,
    "label": "暴虐"
  },
  {
    "id": 9,
    "layer": 7,
    "start": 1.9859,
    "end": 2.178,
    "label": "排斥"
  },
  {
    "id": 10,
    "layer": 7,
    "start": 2.178,
    "end": 2.3989,
    "label": "隠蔽"
  },
  {
    "id": 11,
    "layer": 7,
    "start": 2.3989,
    "end": 2.5967,
    "label": "詭弁"
  },
  {
    "id": 12,
    "layer": 7,
    "start": 2.5967,
    "end": 2.8185,
    "label": "逃避"
  },
  {
    "id": 13,
    "layer": 7,
    "start": 2.8185,
    "end": 3.1416,
    "label": "分裂"
  },
  {
    "id": 14,
    "layer": 7,
    "start": 3.1416,
    "end": 3.4826,
    "label": "喪失"
  },
  {
    "id": 15,
    "layer": 7,
    "start": 3.4826,
    "end": 3.6887,
    "label": "崇拝"
  },
  {
    "id": 16,
    "layer": 7,
    "start": 3.6887,
    "end": 3.8902,
    "label": "平和"
  },
  {
    "id": 17,
    "layer": 7,
    "start": 3.8902,
    "end": 4.1002,
    "label": "調和"
  },
  {
    "id": 18,
    "layer": 7,
    "start": 4.1002,
    "end": 4.3109,
    "label": "尊重"
  },
  {
    "id": 19,
    "layer": 7,
    "start": 4.3109,
    "end": 4.5209,
    "label": "犠牲"
  },
  {
    "id": 20,
    "layer": 7,
    "start": 4.5209,
    "end": 4.7124,
    "label": "寛容"
  },
  {
    "id": 21,
    "layer": 7,
    "start": 4.7124,
    "end": 4.8996,
    "label": "許容"
  },
  {
    "id": 22,
    "layer": 7,
    "start": 4.8996,
    "end": 5.1082,
    "label": "溺愛"
  },
  {
    "id": 23,
    "layer": 7,
    "start": 5.1082,
    "end": 5.3256,
    "label": "追随"
  },
  {
    "id": 24,
    "layer": 7,
    "start": 5.3256,
    "end": 5.5346,
    "label": "無防"
  },
  {
    "id": 25,
    "layer": 7,
    "start": 5.5346,
    "end": 5.7398,
    "label": "傲慢"
  },
  {
    "id": 26,
    "layer": 7,
    "start": 5.7398,
    "end": 5.9738,
    "label": "推進"
  },
  {
    "id": 27,
    "layer": 7,
    "start": 5.9738,
    "end": 6.2832,
    "label": "退廃"
  },
  {
    "id": 28,
    "layer": 6,
    "start": -0.2229,
    "end": 0.2368,
    "label": "パニック"
  },
  {
    "id": 29,
    "layer": 6,
    "start": 0.2368,
    "end": 0.4572,
    "label": "絶望"
  },
  {
    "id": 30,
    "layer": 6,
    "start": 0.4572,
    "end": 0.6464,
    "label": "後悔"
  },
  {
    "id": 31,
    "layer": 6,
    "start": 0.6464,
    "end": 0.8461,
    "label": "自戒"
  },
  {
    "id": 32,
    "layer": 6,
    "start": 0.8461,
    "end": 1.0581,
    "label": "封印"
  },
  {
    "id": 33,
    "layer": 6,
    "start": 1.0581,
    "end": 1.2701,
    "label": "軽蔑"
  },
  {
    "id": 34,
    "layer": 6,
    "start": 1.2701,
    "end": 1.4754,
    "label": "非情"
  },
  {
    "id": 35,
    "layer": 6,
    "start": 1.4754,
    "end": 1.6709,
    "label": "制裁"
  },
  {
    "id": 36,
    "layer": 6,
    "start": 1.6709,
    "end": 1.8791,
    "label": "排他"
  },
  {
    "id": 37,
    "layer": 6,
    "start": 1.8791,
    "end": 2.0899,
    "label": "侮蔑"
  },
  {
    "id": 38,
    "layer": 6,
    "start": 2.0899,
    "end": 2.2955,
    "label": "悲観"
  },
  {
    "id": 39,
    "layer": 6,
    "start": 2.2955,
    "end": 2.4914,
    "label": "卑下"
  },
  {
    "id": 40,
    "layer": 6,
    "start": 2.4914,
    "end": 2.7058,
    "label": "屈従"
  },
  {
    "id": 41,
    "layer": 6,
    "start": 2.7058,
    "end": 2.9245,
    "label": "隷属"
  },
  {
    "id": 42,
    "layer": 6,
    "start": 2.9245,
    "end": 3.3587,
    "label": "異常反応"
  },
  {
    "id": 43,
    "layer": 6,
    "start": 3.3587,
    "end": 3.5837,
    "label": "渇望"
  },
  {
    "id": 44,
    "layer": 6,
    "start": 3.5837,
    "end": 3.7764,
    "label": "期待"
  },
  {
    "id": 45,
    "layer": 6,
    "start": 3.7764,
    "end": 3.9749,
    "label": "謙虚"
  },
  {
    "id": 46,
    "layer": 6,
    "start": 3.9749,
    "end": 4.1843,
    "label": "他尊"
  },
  {
    "id": 47,
    "layer": 6,
    "start": 4.1843,
    "end": 4.4058,
    "label": "敬意"
  },
  {
    "id": 48,
    "layer": 6,
    "start": 4.4058,
    "end": 4.6113,
    "label": "慈悲"
  },
  {
    "id": 49,
    "layer": 6,
    "start": 4.6113,
    "end": 4.823,
    "label": "正義"
  },
  {
    "id": 50,
    "layer": 6,
    "start": 4.823,
    "end": 5.0477,
    "label": "受容"
  },
  {
    "id": 51,
    "layer": 6,
    "start": 5.0477,
    "end": 5.2339,
    "label": "賛美"
  },
  {
    "id": 52,
    "layer": 6,
    "start": 5.2339,
    "end": 5.4335,
    "label": "楽観"
  },
  {
    "id": 53,
    "layer": 6,
    "start": 5.4335,
    "end": 5.6445,
    "label": "自尊"
  },
  {
    "id": 54,
    "layer": 6,
    "start": 5.6445,
    "end": 5.8625,
    "label": "信念"
  },
  {
    "id": 55,
    "layer": 6,
    "start": 5.8625,
    "end": 6.0603,
    "label": "委譲"
  },
  {
    "id": 56,
    "layer": 5,
    "start": -0.1024,
    "end": 0.1184,
    "label": "脅威"
  },
  {
    "id": 57,
    "layer": 5,
    "start": 0.1184,
    "end": 0.3588,
    "label": "憂鬱"
  },
  {
    "id": 58,
    "layer": 5,
    "start": 0.3588,
    "end": 0.5478,
    "label": "惜"
  },
  {
    "id": 59,
    "layer": 5,
    "start": 0.5478,
    "end": 0.7549,
    "label": "恥"
  },
  {
    "id": 60,
    "layer": 5,
    "start": 0.7549,
    "end": 0.9385,
    "label": "嘆"
  },
  {
    "id": 61,
    "layer": 5,
    "start": 0.9385,
    "end": 1.1591,
    "label": "忌"
  },
  {
    "id": 62,
    "layer": 5,
    "start": 1.1591,
    "end": 1.3751,
    "label": "吝"
  },
  {
    "id": 63,
    "layer": 5,
    "start": 1.3751,
    "end": 1.5708,
    "label": "嫉"
  },
  {
    "id": 64,
    "layer": 5,
    "start": 1.5708,
    "end": 1.786,
    "label": "悪"
  },
  {
    "id": 65,
    "layer": 5,
    "start": 1.786,
    "end": 1.9859,
    "label": "憤"
  },
  {
    "id": 66,
    "layer": 5,
    "start": 1.9859,
    "end": 2.178,
    "label": "醜"
  },
  {
    "id": 67,
    "layer": 5,
    "start": 2.178,
    "end": 2.398,
    "label": "悼"
  },
  {
    "id": 68,
    "layer": 5,
    "start": 2.398,
    "end": 2.5938,
    "label": "卑"
  },
  {
    "id": 69,
    "layer": 5,
    "start": 2.5938,
    "end": 2.8029,
    "label": "畏"
  },
  {
    "id": 70,
    "layer": 5,
    "start": 2.8029,
    "end": 3.1079,
    "label": "恐怖"
  },
  {
    "id": 71,
    "layer": 5,
    "start": 3.1079,
    "end": 3.2439,
    "label": "錯乱"
  },
  {
    "id": 72,
    "layer": 5,
    "start": 3.2439,
    "end": 3.4701,
    "label": "陶酔"
  },
  {
    "id": 73,
    "layer": 5,
    "start": 3.4701,
    "end": 3.6876,
    "label": "欲"
  },
  {
    "id": 74,
    "layer": 5,
    "start": 3.6876,
    "end": 3.8925,
    "label": "羞"
  },
  {
    "id": 75,
    "layer": 5,
    "start": 3.8925,
    "end": 4.1048,
    "label": "謝"
  },
  {
    "id": 76,
    "layer": 5,
    "start": 4.1048,
    "end": 4.3147,
    "label": "慕"
  },
  {
    "id": 77,
    "layer": 5,
    "start": 4.3147,
    "end": 4.5107,
    "label": "温"
  },
  {
    "id": 78,
    "layer": 5,
    "start": 4.5107,
    "end": 4.7124,
    "label": "慈"
  },
  {
    "id": 79,
    "layer": 5,
    "start": 4.7124,
    "end": 4.9363,
    "label": "善"
  },
  {
    "id": 80,
    "layer": 5,
    "start": 4.9363,
    "end": 5.135,
    "label": "認"
  },
  {
    "id": 81,
    "layer": 5,
    "start": 5.135,
    "end": 5.3213,
    "label": "美"
  },
  {
    "id": 82,
    "layer": 5,
    "start": 5.3213,
    "end": 5.5283,
    "label": "愉"
  },
  {
    "id": 83,
    "layer": 5,
    "start": 5.5283,
    "end": 5.752,
    "label": "誇"
  },
  {
    "id": 84,
    "layer": 5,
    "start": 5.752,
    "end": 5.9597,
    "label": "信"
  },
  {
    "id": 85,
    "layer": 5,
    "start": 5.9597,
    "end": 6.1808,
    "label": "依存"
  },
  {
    "id": 86,
    "layer": 4,
    "start": -0.1804,
    "end": 0.2314,
    "label": "怪しい"
  },
  {
    "id": 87,
    "layer": 4,
    "start": 0.2314,
    "end": 0.8682,
    "label": "恨(疚)しい"
  },
  {
    "id": 88,
    "layer": 4,
    "start": 0.8682,
    "end": 1.5708,
    "label": "悔しい"
  },
  {
    "id": 89,
    "layer": 4,
    "start": 1.5708,
    "end": 2.2955,
    "label": "苛立たしい"
  },
  {
    "id": 90,
    "layer": 4,
    "start": 2.2955,
    "end": 2.9245,
    "label": "おぞましい"
  },
  {
    "id": 91,
    "layer": 4,
    "start": 2.9245,
    "end": 3.3836,
    "label": "狂おしい"
  },
  {
    "id": 92,
    "layer": 4,
    "start": 3.3836,
    "end": 4.0011,
    "label": "うれ(疚)しい"
  },
  {
    "id": 93,
    "layer": 4,
    "start": 4.0011,
    "end": 4.7124,
    "label": "愛おしい"
  },
  {
    "id": 94,
    "layer": 4,
    "start": 4.7124,
    "end": 5.3465,
    "label": "やさしい"
  },
  {
    "id": 95,
    "layer": 4,
    "start": 5.3465,
    "end": 6.1028,
    "label": "頼もしい"
  },
  {
    "id": 96,
    "layer": 3,
    "start": -0.1521,
    "end": 0.1521,
    "label": "迷い"
  },
  {
    "id": 97,
    "layer": 3,
    "start": 0.1521,
    "end": 0.5343,
    "label": "怖い"
  },
  {
    "id": 98,
    "layer": 3,
    "start": 0.5343,
    "end": 1.0008,
    "label": "切ない"
  },
  {
    "id": 99,
    "layer": 3,
    "start": 1.0008,
    "end": 2.1087,
    "label": "憎い"
  },
  {
    "id": 100,
    "layer": 3,
    "start": 2.1087,
    "end": 2.6036,
    "label": "きつい"
  },
  {
    "id": 101,
    "layer": 3,
    "start": 2.6036,
    "end": 2.9395,
    "label": "つらい"
  },
  {
    "id": 102,
    "layer": 3,
    "start": 2.9395,
    "end": 3.3079,
    "label": "凄い"
  },
  {
    "id": 103,
    "layer": 3,
    "start": 3.3079,
    "end": 3.7517,
    "label": "欲しい"
  },
  {
    "id": 104,
    "layer": 3,
    "start": 3.7517,
    "end": 4.1645,
    "label": "嬉しい"
  },
  {
    "id": 105,
    "layer": 3,
    "start": 4.1645,
    "end": 5.2378,
    "label": "愛しい"
  },
  {
    "id": 106,
    "layer": 3,
    "start": 5.2378,
    "end": 5.6932,
    "label": "楽しい"
  },
  {
    "id": 107,
    "layer": 3,
    "start": 5.6923,
    "end": 6.1311,
    "label": "心強い"
  },
  {
    "id": 108,
    "layer": 2,
    "start": 0,
    "end": 0.4414,
    "label": "不安"
  },
  {
    "id": 109,
    "layer": 2,
    "start": 0.4414,
    "end": 1.2382,
    "label": "悲哀"
  },
  {
    "id": 110,
    "layer": 2,
    "start": 1.2382,
    "end": 1.9386,
    "label": "怒"
  },
  {
    "id": 111,
    "layer": 2,
    "start": 1.9386,
    "end": 2.7542,
    "label": "苦"
  },
  {
    "id": 112,
    "layer": 2,
    "start": 2.7542,
    "end": 3.1416,
    "label": "辛"
  },
  {
    "id": 113,
    "layer": 2,
    "start": 3.1416,
    "end": 3.6013,
    "label": "悦"
  },
  {
    "id": 114,
    "layer": 2,
    "start": 3.6013,
    "end": 4.3659,
    "label": "喜"
  },
  {
    "id": 115,
    "layer": 2,
    "start": 4.3659,
    "end": 5.0396,
    "label": "愛"
  },
  {
    "id": 116,
    "layer": 2,
    "start": 5.0396,
    "end": 5.8737,
    "label": "楽"
  },
  {
    "id": 117,
    "layer": 2,
    "start": 5.8737,
    "end": 6.2832,
    "label": "安心"
  },
  {
    "id": 118,
    "layer": 1,
    "start": 0,
    "end": 0.6714,
    "label": "不安定感"
  },
  {
    "id": 119,
    "layer": 1,
    "start": 0.6714,
    "end": 2.6066,
    "label": "嫌悪感"
  },
  {
    "id": 120,
    "layer": 1,
    "start": 2.6066,
    "end": 3.1416,
    "label": "痛感"
  },
  {
    "id": 121,
    "layer": 1,
    "start": 3.1416,
    "end": 3.7116,
    "label": "快感"
  },
  {
    "id": 122,
    "layer": 1,
    "start": 3.7116,
    "end": 5.6892,
    "label": "好感"
  },
  {
    "id": 123,
    "layer": 1,
    "start": 5.6892,
    "end": 6.2832,
    "label": "安定感"
  },
  {
    "id": 124,
    "layer": 0,
    "start": 0,
    "end": 3.1416,
    "label": "不快"
  },
  {
    "id": 125,
    "layer": 0,
    "start": 3.1416,
    "end": 6.2832,
    "label": "快"
  },
  {
    "id": 126,
    "layer": -1,
    "start": 0,
    "end": 3.1416,
    "label": "生存"
  },
  {
    "id": 127,
    "layer": -1,
    "start": 3.1416,
    "end": 6.2832,
    "label": "増殖"
  }
]);

const TAU = 6.2832;
// The observation pseudo-5-HT adapter keeps only the old ARG11 direction as
// its tonic path.  The full legacy 5HT>T manual remains unchanged below for
// source compatibility, but ARG7 (pleasure -> delight/joy) is not a tonic
// serotonin target in the current demo.
const TONIC_5HT_STABLE_ANGLES = Object.freeze([5.7399, 5.8624, 5.8626, 5.9737]);
const DIRECTION_ANGLES: Readonly<Record<LegacyDirectionName, readonly number[]>> = Object.freeze({
  ENK: [3.4700, 3.5836, 3.5838, 3.6886],
  END: [3.4700, 3.5836, 3.5838, 3.6886, 4.1003, 4.3146, 4.3148, 4.5208, 4.5210, 4.7125, 4.7123, 4.8995, 5.1083, 5.1360, 5.1340, 5.3255, 5.7399, 5.8624, 5.8626, 5.9737],
  OXY: [4.5210, 4.7125, 4.7123, 4.8995],
  "DA>T": [6.2831, 6.2833, 3.1415, 3.1417],
  "DA<T": [0.3589, 0.4571, 0.4573, 0.5567, 2.5968, 2.7057, 2.7059, 2.8184],
  NA: [0.3589, 0.4571, 0.4573, 0.5567, 0.9386, 1.1590, 1.1592, 1.3750, 1.3752, 1.5707, 1.5709, 1.7664, 1.7861, 1.9858, 1.9860, 2.1779, 2.5968, 2.7057, 2.7059, 2.8184],
  VP: [0.9386, 1.1590, 1.1592, 1.3750, 1.7861, 1.9858, 1.9860, 2.1779],
  ACH: [1.3752, 1.5707, 1.5709, 1.7664],
  "5HT>T": [3.4700, 3.5836, 3.5838, 3.6886, 5.7399, 5.8624, 5.8626, 5.9737],
  "5HT<T": [0.3589, 0.4571, 0.4573, 0.5567, 2.5968, 2.7057, 2.7059, 2.8184],
  "5HT=0": [6.2831, 6.2833, 3.1415, 3.1417],
  RIGHT: [5.1083, 5.1360, 5.1340, 5.3255, 5.7399, 5.8624, 5.8626, 5.9737,
    6.2831, 6.2833, 0.3589, 0.4571, 0.4573, 0.5567, 0.9386, 1.1590, 1.1592, 1.3750],
  LEFT: [1.7861, 1.9858, 1.9860, 2.1779, 2.5968, 2.7057, 2.7059, 2.8184,
    3.1415, 3.1417, 3.4700, 3.5836, 3.5838, 3.6886, 4.1003, 4.3146, 4.3148, 4.5208],
});

function oldCppLinks(): LegacyEmotionLink[] {
  const result: LegacyEmotionLink[] = [];
  for (let layer = -1; layer < 7; layer += 1) {
    const sources = LEGACY_EMOTION_CELLS.filter(cell => cell.layer === layer).sort((a, b) => a.id - b.id);
    const targets = LEGACY_EMOTION_CELLS.filter(cell => cell.layer === layer + 1).sort((a, b) => a.id - b.id);
    for (const source of sources) {
      // These variables deliberately persist across the target loop.  That is
      // how create_emomap_cpp_nn_links handles the 0-radian wraparound.
      let sourceStart = source.start;
      let sourceEnd = source.end;
      for (const target of targets) {
        let targetStart = target.start;
        let targetEnd = target.end;
        if (sourceStart <= 0 && targetStart > 4.7124) {
          sourceStart += TAU;
          sourceEnd += TAU;
        }
        if (sourceStart > 4.7124 && targetStart <= 0) {
          targetStart += TAU;
          targetEnd += TAU;
        }
        const linked = (sourceStart < targetStart && targetStart < sourceEnd)
          || (sourceStart < targetEnd && targetEnd < sourceEnd)
          || (targetStart < sourceStart && sourceEnd < targetEnd)
          || (targetStart === sourceStart && sourceEnd === targetEnd);
        if (linked) result.push({
          id: source.id + "->" + target.id,
          source: source.id,
          target: target.id,
          sourceLayer: source.layer,
          targetLayer: target.layer,
        });
      }
    }
  }
  return result;
}

export const LEGACY_EMOTION_LINKS: readonly LegacyEmotionLink[] = Object.freeze(oldCppLinks());

function oldCppDirectionLinks(angles: readonly number[]): ReadonlySet<string> {
  const result = new Set<string>();
  for (const source of LEGACY_EMOTION_CELLS) {
    // The persistence and repeated TAU additions below intentionally match
    // create_emomap_cpp_nn_manuals rather than a geometrically simplified
    // interval-overlap test.
    let temporarySourceStart = source.start;
    let temporarySourceEnd = source.end;
    for (let directionAngle of angles) {
      if (source.start <= 0 && directionAngle > 4.7124) {
        temporarySourceStart += TAU;
        temporarySourceEnd += TAU;
      }
      if (source.start > 4.7124 && directionAngle <= 0) directionAngle += TAU;
      if (temporarySourceStart <= directionAngle && directionAngle <= temporarySourceEnd) {
        for (const link of LEGACY_EMOTION_LINKS.filter(item => item.source === source.id)) {
          const target = LEGACY_EMOTION_CELLS[link.target];
          let targetStart = target.start;
          let targetEnd = target.end;
          for (let nextAngle of angles) {
            if (targetStart <= 0 && nextAngle > 4.7124) {
              targetStart += TAU;
              targetEnd += TAU;
            }
            if (targetStart > 4.7124 && nextAngle <= 0) nextAngle += TAU;
            if (targetStart <= nextAngle && nextAngle <= targetEnd) result.add(link.id);
          }
        }
      }
    }
  }
  return result;
}

export const LEGACY_DIRECTION_LINKS: Readonly<Record<LegacyDirectionName, ReadonlySet<string>>> = Object.freeze(
  Object.fromEntries(Object.entries(DIRECTION_ANGLES).map(([name, angles]) => [name, oldCppDirectionLinks(angles)])) as unknown as Record<LegacyDirectionName, ReadonlySet<string>>,
);

export const LEGACY_TONIC_5HT_STABLE_LINKS: ReadonlySet<string> = Object.freeze(
  oldCppDirectionLinks(TONIC_5HT_STABLE_ANGLES),
);

export const LEGACY_INPUT_ADAPTER = Object.freeze({
  DA: Object.freeze({ high: "DA>T", low: "DA<T" }),
  OP: Object.freeze(["ENK", "END", "OXY"]),
  NA: "NA", Ach: "ACH", VP: "VP",
  "5-HT": Object.freeze({ high: "5HT>T", low: "5HT<T", baseline: "5HT=0" }),
});

export const LEGACY_EMOTION_TUNING = Object.freeze({
  inputBaseline: 0.5,
  upperThreshold: 0.58,
  lowerThreshold: 0.42,
  transmissionThreshold: 0.35,
  membraneDecay: 0.93,
  situationGain: 0.3,
  reactionGain: 0.6,
  propagationGain: 1.0,
  tonic5HtWeightFloor: 0.04,
  tonic5HtNominalActivity: 0.72,
  opioidGains: Object.freeze({ ENK: 1.0, END: 0.72, OXY: 0.58 }),
  weightDeltas: Object.freeze({ ENK: 2.5, END: 0.2, OXY: 0.2, DA: 0.2, NA: 0.2, VP: 0.2, ACH: 0.2, "5-HT": 0.2 }),
});

export type SixIndicatorValues = Record<"DA" | "OP" | "NA" | "Ach" | "VP" | "5-HT", number>;
export interface LegacyOriginInput {
  cells: SixIndicatorValues;
  connections: SixIndicatorValues;
  lastTriggerStrength: number;
  decay: { coefficient: number };
}
export interface LegacyIndividualInput {
  indicators: SixIndicatorValues;
  situation: LegacyOriginInput;
  reaction: LegacyOriginInput;
}
export interface LegacyGraphResult {
  linkWeights: Readonly<Record<string, number>>;
  membranePotentials: readonly number[];
  boosts: Readonly<Record<LegacyManualName, number>>;
}

export interface EncodedLegacyGraphState {
  encoding: "legacy-fixed-state/v1";
  membrane_decay: number;
  propagation_order: "inner-to-outer/-1..6";
  membrane_potentials: string;
  link_weights_f32: string;
  boosts: Readonly<Record<LegacyManualName, number>>;
}

function decodeUnitArray(encoded: string, expectedLength: number): number[] {
  try {
    const binary = atob(encoded);
    if (binary.length !== expectedLength) return [];
    return Array.from(binary, character => character.charCodeAt(0) / 255);
  } catch {
    return [];
  }
}

function decodeFloat32Array(encoded: string, expectedLength: number): number[] {
  try {
    const binary = atob(encoded);
    if (binary.length !== expectedLength * Float32Array.BYTES_PER_ELEMENT) return [];
    const bytes = Uint8Array.from(binary, character => character.charCodeAt(0));
    const view = new DataView(bytes.buffer);
    return Array.from({ length: expectedLength }, (_, index) => view.getFloat32(index * 4, true));
  } catch {
    return [];
  }
}

export function decodeLegacyEmotionGraph(state: EncodedLegacyGraphState): LegacyGraphResult | null {
  if (state?.encoding !== "legacy-fixed-state/v1" || !state.boosts) return null;
  if (state.membrane_decay !== LEGACY_EMOTION_TUNING.membraneDecay
    || state.propagation_order !== "inner-to-outer/-1..6") return null;
  const membranePotentials = decodeUnitArray(state.membrane_potentials, LEGACY_EMOTION_CELLS.length);
  const decodedWeights = decodeFloat32Array(state.link_weights_f32, LEGACY_EMOTION_LINKS.length);
  if (membranePotentials.length !== LEGACY_EMOTION_CELLS.length
    || decodedWeights.length !== LEGACY_EMOTION_LINKS.length) return null;
  return {
    membranePotentials,
    linkWeights: Object.fromEntries(LEGACY_EMOTION_LINKS.map((link, index) => [link.id, decodedWeights[index]])),
    boosts: state.boosts,
  };
}
